Vue.component('v-main', {
  props: ['site'],
  mounted: function () {
    var slider = $(this.$el).find('.banners')
    var jobSlider = $(this.$el).find('.main__job-slider')
    var calendar = $(this.$el).find('.main__calendar #calendar')
    var scrollContainer = $(this.$el).find('.main__scroll-container .container-bounded ')
    var scrollEventsContainer = $(this.$el).find('.events__content-wrap')
    var scrollStoriesContainer = $(this.$el).find('.stories__content-wrap')
    var qr = $(this.$el).find('.main__qr')
    var bg
    var fill
    var scrollContainerHeight = 0
    switch (this.$store.color) {
      case 'black':
        bg = 'black'
        fill = 'white'
        break
      case 'blue':
        bg = '#9dd1ff'
        fill = 'black'
        break
      default:
        bg = 'white'
        fill = 'black'
    }

    qr.qrcode({
      text: 'http://' + this.site + '/getapp',
      size: 120,
      fill: fill,
      background: bg
    })

    scrollEventsContainer.slimScroll({
      height: '285px',
      size: '4px',
      color: '#C4C4C4'
    })

    scrollStoriesContainer.slimScroll({
      height: '550px',
      size: '4px',
      color: '#C4C4C4'
    })

    slider.on('init', function (event, slick) {
      scrollContainerHeight = $('.banners__carousel-item')[0].offsetHeight
      scrollContainer.slimScroll({
        height: scrollContainerHeight ? 265 + scrollContainerHeight + 'px' : '380px',
        size: '4px',
        color: '#C4C4C4'
      })
    })
    slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: true,
      infinite: true,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true
    })
    jobSlider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      cssEase: 'linear'
    })

    calendar
      .datetimepicker({
        inline: true,
        viewMode: 'days',
        format: 'DD/MM/YYYY',
        locale: 'ru'
      })
      .on('dp.update', this.highlightDateHome)
    $(this.$el)
      .find('.main__calendar .prev')
      .html('<svg width="10" height="17"><use xlink:href="#svg-arrow-prev-cal-icon" /></svg>')
    $(this.$el)
      .find('.main__calendar .next')
      .html('<svg width="10" height="17"><use xlink:href="#svg-arrow-next-cal-icon" /></svg>')

    this.highlightDateHome()

    $(this.$el)
      .find('.datepicker .day')
      .click(function () {
        return false
      })
    $(this.$el)
      .find('.datepicker .picker-switch')
      .click(function () {
        return false
      })

    $(this.$el)
      .find('.datepicker .day.highlight')
      .click(function () {
        var url_arr = $(this).attr('data-day').split('.')

        document.location.href = '/events/' + url_arr[2] + '/' + url_arr[1] + '/' + url_arr[0]
        return false
      })
    this.setBanner()
  },
  methods: {
    setBanner() {
      var banner = $('#js-show-iframe-wrapper')
      var bannerContainer = $(this.$el).find('.main__banner')
      if (banner.length && bannerContainer.length) {
        bannerContainer.append(banner)
        banner.show()
      }
    },
    highlightDateHome() {
      var self = this
      var daysString = $(this.$el).find('.main__calendar #calendar').data('day')
      var days = []
      if (daysString) {
        days = daysString.split(',')
        $.each(days, function (index, item) {
          $(self.$el)
            .find('#calendar td[data-day="' + item + '"]')
            .addClass('highlight')
        })
      }
    }
  }
})
